/**
 * Aviso de que o logotipo da clínica mudou — trilha T6.
 *
 * Quem envia é a aba de Configurações; quem mostra é o shell, no topo. Um evento
 * de janela evita que o shell dependa de uma tela, e que a tela precise saber
 * que existe um topo para atualizar.
 */
export const EVENTO_DO_LOGO = 'vecchia:logo-da-clinica';
